import { getLogger } from '../logger';
import { generateBase64UUId } from '../util/strings';
import Cookies from 'js-cookie';
import { cookiesEnabled } from '../clientId';
import throttle from 'lodash/throttle.js';
import once from 'lodash/once.js';
import { getTopLevelDomain } from '@snapchat/parse-domain';

const log = getLogger('webSessionId');
const blizzardSessionCookieName = 'blizzard_web_session_id';
let webSessionId: string | undefined = undefined;

/** Returns the current web session id. */
export function getWebSessionId(): string {
  // For now, we won't let users disable either clientId or webSessionId separately. Users have to enable cookies for both Ids, or not use cookies at all.
  if (cookiesEnabled) {
    webSessionId = Cookies.get(blizzardSessionCookieName); // webSessionId is always loaded from cookies if cookies is enabled
    if (webSessionId !== undefined) {
      log.info('Loaded blizzardWebSessionId from cookies:', webSessionId);
    } else {
      webSessionId = generateAndSaveWebSessionIdInCookies();
    }
  } else {
    return '';
  }

  return webSessionId;
}

/** Generates a new session id and stores it in a cookie. */
function generateAndSaveWebSessionIdInCookies(): string {
  const webSessionId = generateBase64UUId();
  saveWebSessionIdInCookies(webSessionId);
  log.info('Generated new webSessionId and saved in cookies:', webSessionId);
  return webSessionId;
}

/** Saves the current web session id in a cookie. */
export function saveWebSessionIdInCookies(webSessionId: string): void {
  Cookies.set(blizzardSessionCookieName, webSessionId, {
    expires: 1 / 48, // 30 minutes. Not configurable
    domain: getTopLevelDomain(self.location.hostname), // shared subdomain. Not configurable
  });
  log.info('Saved current webSessionId in cookies');
}

const eventsArray = [
  'keypress',
  'keydown',
  'click',
  'contextmenu',
  'dblclick',
  'mousemove',
  'scroll',
  'touchmove',
  'touchstart',
  'mousedown',
  'keyup',
];

/** Saves the web session id in cookies when the user is active. */
export const saveWebSessionIdWhenActive = once(() => {
  if (!cookiesEnabled) {
    return;
  }

  const throttleFn = throttle(() => {
    saveWebSessionIdInCookies(getWebSessionId());
  }, 1000); // only triggered once every 1 sec
  for (let i = 0; i < eventsArray.length; i++) {
    window.addEventListener(eventsArray[i], throttleFn);
    log.info('set eventListener for', eventsArray[i]);
  }
});
